import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=a676aabe&scoped=true"
import script from "./IconSvg.vue?vue&type=script&lang=js"
export * from "./IconSvg.vue?vue&type=script&lang=js"
import style0 from "./IconSvg.vue?vue&type=style&index=0&id=a676aabe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a676aabe",
  null
  
)

export default component.exports